<% if (valid_age_range) { %>
  <div class="message message-warning">
    <p><strong><%= I18n.messages.age_range.title %></strong></p>
    <p>
      <% if (valid_age_range.minimum_age && valid_age_range.maximum_age) { %>
        <%= I18n.messages.age_range.unavailable_between.replace('%{minimum}', valid_age_range.minimum_age).replace('%{maximum}', valid_age_range.maximum_age) %>
      <% } else if (valid_age_range.minimum_age) { %>
        <%= I18n.messages.age_range.unavailable_under.replace('%{minimum}', valid_age_range.minimum_age) %>
      <% } else if (valid_age_range.maximum_age) { %>
        <%= I18n.messages.age_range.unavailable_over.replace('%{maximum}', valid_age_range.maximum_age) %>
      <% } %>
    </p>
    <p>
      <% if (address && address.phone_number) { %>
        <%= I18n.messages.age_range.returning_patient_html.replaceAll('%{phone_number}', address.phone_number) %>
      <% } %>
      <%= I18n.messages.age_range.new_patient_html.replaceAll('%{phone_number}', I18n.help_phone_number) %>
    </p>
  </div>
<% } %>
